import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import LoginSsoForm from '../../components/entrance/LoginSsoForm';
import { Row, Col, Container } from "shards-react";

const roleConfig = {
    student: { label: 'Mahasiswa', color: '#16a34a', shadow: 'rgba(22,163,74,0.3)' },
    lecturer: { label: 'Dosen', color: '#1d4ed8', shadow: 'rgba(29,78,216,0.3)' },
};

function LoginPage() {
    const [role, setRole] = useState('student');

    return (
        <div id="page" style={{ height: '100%' }}>
            <Row style={{ margin: '0', height: '100%' }}>
                <Col sm="12" lg="6" style={{ padding: '0 4em' }}>
                    <Container style={{ textAlign: 'center' }}>
                        <img src="/images/fri.png" style={{ maxHeight: '10em', margin: '5em 0 2em 0' }} />
                        <p style={{ marginBottom: '1.5em' }}>Selamat Datang di Aplikasi Pendaftaran TA</p>

                        {/* Toggle */}
                        <div style={{
                            display: 'inline-flex', backgroundColor: '#f3f4f6',
                            borderRadius: 999, padding: 4, marginBottom: '2em', gap: 4,
                        }}>
                            {Object.entries(roleConfig).map(([key, { label, color, shadow }]) => (
                                <button key={key} type="button" onClick={() => setRole(key)} style={{
                                    padding: '0.45rem 1.25rem', borderRadius: 999, border: 'none',
                                    cursor: 'pointer', fontWeight: 600, fontSize: '0.875rem',
                                    backgroundColor: role === key ? color : 'transparent',
                                    color: role === key ? '#fff' : '#6b7280',
                                    boxShadow: role === key ? `0 2px 6px ${shadow}` : 'none',
                                    transition: 'all 0.15s',
                                }}>
                                    {label}
                                </button>
                            ))}
                        </div>
                    </Container>

                    <LoginSsoForm userType={role} activeColor={roleConfig[role].color} />
                </Col>
                <Col sm="12" lg="6">
                    <div className="gedungFRI"></div>
                </Col>
            </Row>
        </div>
    );
}

ReactDOM.render(<LoginPage />, document.getElementById('root'));